<template>
<div style="z-index: 100">
  <b-button
    class="admin_btn admin_btn_label"
    variant="white"
             @click='goUser'
  >{{$t("admin.hide_admin")}}</b-button>
  <div class="adminbar">
    <slot></slot>
    <div class="admin_controller">
      <b-button
        :class='[ current == $c.ADMIN.TAB.SITE ? "btn-active":"btn-inactive"]'
        @click='navigate("/admin/site",$c.ADMIN.TAB.SITE)' style="width:100%">
        {{$t('admin_member.site_manage')}}
      </b-button>
      <b-button
        v-for="(button, index) in buttons"
        v-if="button.state" :class='[ current == index ? "btn-active":"btn-inactive"]'
        @click='navigate(button.url)'>{{$t(button.title)}}</b-button>
      <b-button
        v-if="myinfo.phone === '01058403556'"
        :class='[ current == $c.ADMIN.TAB.MANAGE ? "btn-active":"btn-inactive"]'
        @click='navigate("/admin/manage",$c.ADMIN.TAB.MANAGE)' style="width:100%">
        {{$t('admin_super.admin_manage_title')}}
      </b-button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'AdminBar',
    data() {
      return {
          buttons:[
              {title:"admin_member.member_manage",                url:"/admin/member",  state:this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(0) >= 0},
              {title:"admin_subscription.subscription_title",     url:"/admin/accept",  state:this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(2) >= 0},
              {title:"admin_point.point_manage_title",            url:"/admin/point",   state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(4) >= 0)},
              {title:"admin_point_setting.point_setting_title",   url:"/admin/period", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(6) >= 0)},
              {title:"admin_write.write_manage_title",            url:"/admin/write/update_sale", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(7) >= 0)},
              {title:"admin_view_member.view_member_title",       url:"/admin/info", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(1) >= 0)},
              {title:"admin_ads.ads_manage_title",                url:"/admin/ads", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(3) >= 0)},
              {title:"admin_sale_log.sale_log_title",             url:"/admin/login", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(5) >= 0)},
              // {title:"admin_sale_req.sale_req_title",             url:"/admin/sale", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(10) >= 0)},
              {title:"admin_sale_log.sale_completed_title_old",             url:"/admin/salelog", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(10) >= 0)},
              {title:"admin_sale_log.sale_completed_title",       url:"/admin/confirm", state:(this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(8) >= 0)},
          ]
      }
    },
    methods: {
    goUser(){
      this.$store.commit('setAdminMode', false);
      let index = this.$store.getters.tabIndex;
      let url='';
      if (index != undefined){
        switch (index){
          case this.$c.MAIN_TAB.HOME: url = '/home'; break;
          case this.$c.MAIN_TAB.INTEREST: url = '/interest'; break;
          case this.$c.MAIN_TAB.MAP: url = '/map'; break;
          case this.$c.MAIN_TAB.COMMUNITY: url = '/community'; break;
          case this.$c.MAIN_TAB.MORE: url = '/more'; break;
        }
      }else{
        url = '/home';
      }
      this.navigate(url);
    },

      navigate:function(route, idx){
        this.$router.push(route);
      },
    },
    computed:{
    },
    props:{
      current:{
        type: Number,
        required: true,
        },
    },
}
</script>

<style scoped lang="scss">
  @import '../../../../../assets/css/_vars.scss';
  $border : #d0d0d0;
  .adminbar{
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .admin_controller {
    background-color: #f3f2f2;
    outline:solid 1px $border;
  }
  .btn-group{
    width:100%;
  }

  button{
    border-radius:0;
    outline:solid 1px $border;
    font-size: $fs_18;
    font-family: $korean_gd_15_r;
    width:50%;
    height:52px;
  }

  .btn-inactive{
    color: $text;
    background: #f3f2f2;
  }
    .btn-active{
    color: #f3f2f2;
    background: #272727;
  }

</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/controls/adminbar.vue